export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deleteStaff.vue?vue&type=template&id=2af31968&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/deleteStaff.vue?vue&type=template&id=2af31968&
// module id = 1652
// module chunks = 0